import type { ColumnHelper, ColumnMeta } from '@tanstack/react-table';

export const lastUpdatedByAccessor = <T extends { last_updated_by?: string }>(
  columnHelper: ColumnHelper<T>,
  filterMeta: ColumnMeta<T, string>['filter'] = {},
  updatedByUsers?: string[],
) =>
  columnHelper.accessor((row) => row.last_updated_by, {
    id: 'last_updated_by',
    header: 'Updated by',
    size: 180,
    minSize: 180,
    maxSize: 180,
    filterFn: 'arrIncludesSome',
    meta: {
      filter: {
        type: 'dropdown',
        placeholder: 'All users',
        options: updatedByUsers,
        ...filterMeta,
      },
    },
  });
